import { render, staticRenderFns } from "./material1.vue?vue&type=template&id=03c5bf9a&scoped=true&"
import script from "./material1.vue?vue&type=script&lang=js&"
export * from "./material1.vue?vue&type=script&lang=js&"
import style0 from "./material1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./material1.vue?vue&type=style&index=1&id=03c5bf9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c5bf9a",
  null
  
)

export default component.exports